(function() {
  'use strict';

  if (window.SSDatePickerLoaded) return;
  window.SSDatePickerLoaded = true;

  var _cfg = window.ssDateConfig || {};
  var CONFIG = {
    minDays: _cfg.minDays || 2,
    maxDays: _cfg.maxDays || 90,
    blockedDates: _cfg.blockedDates || [],
    blockedDays: [0],
    attr: 'Data de Retiro',
    months: _cfg.months || ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
    dayNames: _cfg.days || ['Domingo','Segunda','Terça','Quarta','Quinta','Sexta','Sábado'],
    errorMsg: _cfg.errorMsg || 'Por favor, selecione uma data de retiro'
  };

  var currentMonth, currentYear, selectedDate = null;

  function formatDate(d) {
    return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0');
  }

  function isValidDate(dateStr) {
    if (!dateStr) return false;
    var p = dateStr.split('-');
    if (p.length !== 3) return false;
    var dt = new Date(parseInt(p[0]), parseInt(p[1])-1, parseInt(p[2]));
    dt.setHours(0,0,0,0);

    if (CONFIG.blockedDays.indexOf(dt.getDay()) !== -1) return false;
    if (CONFIG.blockedDates.indexOf(dateStr) !== -1) return false;

    var today = new Date(); today.setHours(0,0,0,0);
    var min = new Date(today); min.setDate(min.getDate() + CONFIG.minDays);
    var max = new Date(today); max.setDate(max.getDate() + CONFIG.maxDays);

    return dt >= min && dt <= max;
  }

  function canCheckout() {
    var el = document.getElementById('ss-datepicker');
    if (!el) return true;
    var input = document.getElementById('ss-date-value');
    var val = input ? input.value : '';
    return !!(val && isValidDate(val));
  }

  function showError() {
    var err = document.getElementById('ss-date-error');
    if (err) err.style.display = 'block';
    var dp = document.getElementById('ss-datepicker');
    if (dp) dp.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function hideError() {
    var err = document.getElementById('ss-date-error');
    if (err) err.style.display = 'none';
  }

  // ===== INTERCEPTOR DE CHECKOUT (estilo Dengo) =====
  document.addEventListener('click', function(e) {
    var el = e.target;
    while (el && el !== document.body) {
      // Skip add-to-cart
      var form = el.closest && el.closest('form');
      if (form && form.action && form.action.indexOf('/cart/add') !== -1) break;

      var isCheckout = false;
      if (el.id === 'checkout') isCheckout = true;
      if (el.name === 'checkout') isCheckout = true;
      if (el.href && el.href.indexOf('checkout') !== -1) isCheckout = true;
      if (el.className && typeof el.className === 'string' && el.className.indexOf('checkout') !== -1) isCheckout = true;

      if (el.tagName === 'BUTTON' || el.tagName === 'A' || el.tagName === 'INPUT') {
        var text = (el.textContent || el.innerText || el.value || '').toLowerCase().trim();
        if (text === 'pagar' || text === 'checkout' || text === 'finalizar a compra' || text === 'finalizar compra') {
          isCheckout = true;
        }
      }

      if (el.tagName === 'A' && el.href && el.href.indexOf('/checkout') !== -1) {
        isCheckout = true;
      }

      if (isCheckout) {
        if (!canCheckout()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          showError();
          return false;
        }
        // Save to cart attributes right before checkout
        saveBeforeCheckout();
      }
      el = el.parentElement;
    }
  }, true);

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.action || '';
    if (action.indexOf('/cart/add') !== -1) return;
    if (action.indexOf('checkout') !== -1 || form.querySelector('[name="checkout"]')) {
      if (!canCheckout()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        showError();
        return false;
      }
      saveBeforeCheckout();
    }
  }, true);

  function saveBeforeCheckout() {
    var input = document.getElementById('ss-date-value');
    var val = input ? input.value : '';
    if (val) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Data de Retiro': val } })
      });
    }
  }

  // ===== CALENDARIO =====
  function renderCalendar() {
    var grid = document.getElementById('ss-days-grid');
    var label = document.getElementById('ss-month-label');
    if (!grid || !label) return;

    label.textContent = CONFIG.months[currentMonth] + ' ' + currentYear;
    grid.innerHTML = '';

    var firstDay = new Date(currentYear, currentMonth, 1).getDay();
    var daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    var today = new Date(); today.setHours(0,0,0,0);

    for (var i = 0; i < firstDay; i++) {
      var empty = document.createElement('span');
      empty.className = 'ss-dp__day ss-dp__day--disabled';
      grid.appendChild(empty);
    }

    for (var d = 1; d <= daysInMonth; d++) {
      var date = new Date(currentYear, currentMonth, d);
      var dateStr = formatDate(date);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = d;

      if (isValidDate(dateStr)) {
        btn.className = 'ss-dp__day ss-dp__day--available';
        btn.setAttribute('data-date', dateStr);
        btn.addEventListener('click', onDayClick);
      } else {
        btn.className = 'ss-dp__day ss-dp__day--disabled';
      }

      if (date.getTime() === today.getTime()) btn.className += ' ss-dp__day--today';
      if (selectedDate && date.getTime() === selectedDate.getTime()) btn.className += ' ss-dp__day--selected';

      grid.appendChild(btn);
    }
  }

  function onDayClick(e) {
    e.stopPropagation();
    var dateStr = e.target.getAttribute('data-date');
    var p = dateStr.split('-');
    selectedDate = new Date(parseInt(p[0]), parseInt(p[1])-1, parseInt(p[2]));

    // Set hidden input (travels with cart form)
    var input = document.getElementById('ss-date-value');
    if (input) input.value = dateStr;

    // Persist in sessionStorage (survives drawer close/open)
    try { sessionStorage.setItem('ss_date_retiro', dateStr); } catch(ex) {}

    renderCalendar();
    showSelected();
    hideError();
  }

  function showSelected() {
    var el = document.getElementById('ss-selected-date');
    var label = document.getElementById('ss-selected-label');
    if (!el || !label || !selectedDate) return;
    label.textContent = CONFIG.dayNames[selectedDate.getDay()] + ', ' +
      selectedDate.getDate() + ' de ' + CONFIG.months[selectedDate.getMonth()] + ' ' + selectedDate.getFullYear();
    el.style.display = 'flex';
  }

  function clearDate(e) {
    if (e) e.stopPropagation();
    selectedDate = null;
    var input = document.getElementById('ss-date-value');
    if (input) input.value = '';
    try { sessionStorage.removeItem('ss_date_retiro'); } catch(ex) {}
    var el = document.getElementById('ss-selected-date');
    if (el) el.style.display = 'none';
    renderCalendar();
  }

  // ===== INIT =====
  function init() {
    var container = document.getElementById('ss-datepicker');
    if (!container) return;

    var today = new Date();
    currentMonth = today.getMonth();
    currentYear = today.getFullYear();

    // Check existing value: hidden input > sessionStorage
    var input = document.getElementById('ss-date-value');
    var existing = input ? input.value : '';
    if (!existing) {
      try { existing = sessionStorage.getItem('ss_date_retiro') || ''; } catch(ex) {}
      if (existing && input) input.value = existing;
    }
    if (existing && isValidDate(existing)) {
      var p = existing.split('-');
      selectedDate = new Date(parseInt(p[0]), parseInt(p[1])-1, parseInt(p[2]));
      currentMonth = selectedDate.getMonth();
      currentYear = selectedDate.getFullYear();
    }

    renderCalendar();
    if (selectedDate) showSelected();

    // Bind nav
    var prev = document.getElementById('ss-prev-month');
    var next = document.getElementById('ss-next-month');
    var clear = document.getElementById('ss-clear-date');
    if (prev) prev.onclick = function() { currentMonth--; if (currentMonth < 0) { currentMonth = 11; currentYear--; } renderCalendar(); };
    if (next) next.onclick = function() { currentMonth++; if (currentMonth > 11) { currentMonth = 0; currentYear++; } renderCalendar(); };
    if (clear) clear.onclick = clearDate;
  }

  // Detect DOM changes (cart drawer reloads)
  var lastEl = null;
  function checkAndInit() {
    var el = document.getElementById('ss-datepicker');
    if (el && el !== lastEl) {
      lastEl = el;
      init();
    }
    requestAnimationFrame(checkAndInit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { checkAndInit(); });
  } else {
    checkAndInit();
  }

  window.addEventListener('pageshow', function(e) { if (e.persisted) { lastEl = null; } });
})();
